import { createSelector } from 'reselect'
import { selectEnvConfigFromState } from 'src/redux/selectors/session.selectors'

export const selectVaultHostFromState = createSelector(
  [selectEnvConfigFromState],
  (envConfig) => envConfig.VAULT_HOST || 'https://v-stage.paywithextend.com',
)
